export enum SectionType {
    ClinicHistory = 1,
    VitalSigns = 2,
    PatientForm = 3,
    UserTreatment = 4
}